(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-login/assets/javascripts/react/components/shared/polling-desktop.js') >= 0) return;  svs.modules.push('/modules/iam-login/assets/javascripts/react/components/shared/polling-desktop.js');


'use strict';

const {
  Button
} = svs.ui;
const {
  Loader
} = svs.components.ReactLoader;
const {
  useSetAtom
} = jotai;
const {
  isPollingAtom
} = svs.iam_login.atoms;
const {
  isPnp
} = svs.iam_login.data;
const PollingDesktop = () => {
  const setIsPolling = useSetAtom(isPollingAtom);
  return React.createElement("div", null, React.createElement("div", {
    className: "spinner-container"
  }, React.createElement("p", {
    className: "spinner-container-text"
  }, "V\xE4ntar p\xE5 identifiering i app"), React.createElement(Loader, {
    inverted: !isPnp
  })), React.createElement(Button, {
    block: true,
    className: "",
    inverted: isPnp,
    onClick: () => {
      svs.accountservices.authenticate.login.cancel();
      setIsPolling(false);
    },
    size: 300,
    transparent: true
  }, "Avbryt"));
};
svs.iam_login.components.shared.PollingDesktop = PollingDesktop;

 })(window);